import { ExtStatsVersionCheckI } from "./stats-version-check.result.ext";
import { ExtStatsVersionCheckQueryI } from "./stats-version-check.query.ext";
import { StatsVersionCheckI } from "./stats-version-check.result.int";
import { StatsVersionCheckQueryI } from "./stats-version-check.query.int";
import { nullToEmptyString } from "src/app/shared/helpers/shared-zero-to-null.function";

export const MapStatsVersionCheck = {
    mapQuery: (int: StatsVersionCheckQueryI): ExtStatsVersionCheckQueryI => {
        return {
            request: {
                app: nullToEmptyString(int.app),
                bundleVersion: nullToEmptyString(int.bundleVersion),
            }
        };
    },
    mapResult: (ext: ExtStatsVersionCheckI, _params): StatsVersionCheckI => {
        return {
            ok: ext.response.ok,
            expireDate: ext.response.expireDate,
            expireStatus: ext.response.expireStatus,
            warning: ext.response.warning,
        };
    }
};
